export default "/packs/images/hand@2x~72852e4813de6d54c2512a1af85bef0b.png";